document.querySelectorAll( '.b-countdown' ).forEach( ( block ) => {

	const date = block.dataset.eventDate;
	const time = block.dataset.eventTime;
	const daysContainer = block.querySelector( '.js-timer-days .timer-box__value' );
	const hoursContainer = block.querySelector( '.js-timer-hours .timer-box__value' );
	const minutesContainer = block.querySelector( '.js-timer-minutes .timer-box__value' );
	const secondsContainer = block.querySelector( '.js-timer-seconds .timer-box__value' );

	if ( !date || !time || !daysContainer || !hoursContainer || !minutesContainer || !secondsContainer ) {

		return;

	}

	const [day, month, year] = date.split( '.' );
	const eventDate = new Date( `${year}-${month}-${day}T${time}` );

	const interval = setInterval( updateCountdown, 1000 );

	/**
	 * Updates the countdown display or stops it if the event date has passed.
	 * Converts the time difference into days, hours, minutes, and seconds.
	 *
	 * @return {void}
	 */
	function updateCountdown() {

		const now = new Date();
		const diff = eventDate - now;

		if ( diff <= 0 ) {

			clearInterval( interval );
			return;

		}

		const seconds = Math.floor( diff / 1000 ) % 60;
		const minutes = Math.floor( diff / 1000 / 60 ) % 60;
		const hours   = Math.floor( diff / 1000 / 60 / 60 ) % 24;
		const days    = Math.floor( diff / 1000 / 60 / 60 / 24 );

		daysContainer.innerText = `${days}`;
		hoursContainer.innerText = hours <= 9 ? `0${hours}` : `${hours}`;
		minutesContainer.innerText = minutes <= 9 ? `0${minutes}` : `${minutes}`;
		secondsContainer.innerText = seconds <= 9 ? `0${seconds}` : `${seconds}`;

	}

	updateCountdown();

} );
